module.exports = __webpack_public_path__ + "static/media/arial.fa3228aa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/project/sections/LeasingComponents/BrineTemplates/arial.ttf
// module id = 2526
// module chunks = 0